import React from "react";
import { If } from "../If";
import { t } from "../../i18n";
import { UserStore } from "../../stores/UserStore";
import { inject, observer } from "mobx-react";
import { navigation } from "../../models/navigation";

interface ISiNavigationProps {
  userStore?: UserStore;
}

export const SiNavigation = inject("userStore")(observer(class SiNavigation extends React.Component<ISiNavigationProps> {
  private userStore: UserStore;

  constructor(props: ISiNavigationProps) {
    super(props);
    if (!props.userStore) {
      throw new Error("userStore is not defined");
    }

    this.userStore = props.userStore;
  }

  get canViewReports() {
    return (
      this.userStore.user &&
      (this.userStore.user.isAppAdmin ||
        this.userStore.user.isDistrictAdmin ||
        this.userStore.user.isSchoolAdmin)
    );
  }

  get contentEnabled() {
    return (
      this.userStore.user &&
      (this.userStore.user.districtContentEnabled ||
        this.userStore.user.schoolContentEnabled)
    )
  }

  render(): React.ReactNode {
    const navItems = navigation
      .filter(item => item.nav)
      .filter(item => {
        if (!item.canUserOpen) {
          return true;
        }
        return item.canUserOpen(this.userStore.user);
      });

    return (
      <If predicate={navItems && navItems.length > 0}>
        <si-navigation>
          <nav>
            <If predicate={this.userStore.isAuthenticated}>
              <a href={this.contentEnabled ? "#/dashboard" :"#/"}>{this.contentEnabled ? "Browse Videos" : "Home"}</a>
            </If>

            {navItems.map((item, index) => (
              <If
                key={index}
                predicate={!item.auth || this.userStore.isAuthenticated}
              >
                <a href={item.href}>{t(item.title)}</a>
              </If>
            ))}

            <If predicate={this.canViewReports}>
              <a href="#/reports">Reports</a>
            </If>

            <If predicate={this.userStore.isAuthenticated}>
              <a href="#/profile">
                <i className="material-icons">account_circle</i>

                <If predicate={this.userStore.user.firstName}>
                  <span>{t(this.userStore.user.firstName)}</span>
                </If>
                <If predicate={!this.userStore.user.firstName}>
                  <span>{t(this.userStore.user.username)}</span>
                </If>
              </a>
            </If>
          </nav>
        </si-navigation>
      </If>
    );
  }
}));
